module.exports = __webpack_public_path__ + "static/img/register-code.e52a514.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/online_service/register-code.png
// module id = i18d
// module chunks = 1